<form (ngSubmit)="validarFormulario(formPersonSearch)" #formPersonSearch="ngForm">
    <div class="card">
        <div class="card-header" *ngIf="!paraCaso && (persona.TipoPersona == 2 || persona.TipoPersona == 3)">
            <h5>Buscar Clientes</h5>
        </div>
        <div class="card-block">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>
                            {{ persona.TipoPersona == 2
                            ? 'Nombre(s) o Razón Social'
                            : 'Nombre(s)'
                            }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder='Nombre' [(ngModel)]="persona.Nombre"
                            name="Nombre"
                        >
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>Apellido Paterno</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder='Apellido Paterno'
                            [(ngModel)]="persona.ApellidoPaterno"
                            name="ApellidoPaterno"
                        >
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>Apellido Materno</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder='Apellido Materno'
                            [(ngModel)]="persona.ApellidoMaterno"
                            name="ApellidoMaterno"
                        >
                    </div>
                </div>
            </div>
            <div *ngIf="(persona.TipoPersona == 2 || persona.TipoPersona == 3) 
            && (+persona.PersonalidadFiscalId !== 2)">
                <div class=" row">
                    <div class="col">
                        <div class="form-group">
                            <label>CURP</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="CURP" [(ngModel)]="persona.CURP"
                                name="curp" 
                                autocomplete="off" 
                                (keypress)="validarSoloTexto($event, persona.CURP,20)" 
                            />
                        </div>
                    </div>

                    <div class="col">
                        <div class="form-group">
                            <label>Nivel de Riesgo</label>
                            <select 
                                class="form-control" [(ngModel)]="persona.RiesgoId"
                                (change)="seleccionarNivelRiesgo($event.target.value)"
                                name="RiesgoId" required
                                #RiesgoId="ngModel">

                                <option value="-1">Selecciona una Opción</option>
                                <option *ngFor="let riesgo of nivelRiesgo" 
                                    [value]="riesgo.riesgoId">
                                    {{ riesgo.riesgo }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <h4 class="sub-title">Desde - Hasta</h4>
                        <div class="row">
                            <div class="col-6">
                                <input 
                                    type="date"
                                    class="form-control"
                                    [(ngModel)]="persona.FechaInicialRegistro"
                                    name="FechaInicial"
                                />
                            </div>
                            <div class="col-6">
                                <input 
                                    type="date"
                                    class="form-control"
                                    [(ngModel)]="persona.FechaFinalRegistro"
                                    name="FechaFinal"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="tipoPersona == 2">
                <div class="row">
                    <div class="col" *ngIf="tipoPersonaCombo == 2">
                        <div class=" form-group ">
                            <label for="exampleSelect1 ">Personalidad Fiscal</label>
                            <select class="form-control" name="PersonalidadFiscal"
                                [(ngModel)]="persona.PersonalidadFiscalId"
                                (change)="onChangePersonalidadFiscal()">

                                <option [value]="-1">Selecciona una Opción</option>

                                <option *ngFor="let pFiscal of personalidadFiscal"
                                    [value]="pFiscal.personalidadFiscalId">
                                    {{ pFiscal.personalidadFiscal }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col" *ngIf="tipoPersonaCombo==2">
                        <div class="form-group ">
                            <label>R.F.C</label>
                            <input 
                                type="text"
                                class="form-control"
                                placeholder='R.F.C' [(ngModel)]="persona.RFC"
                                name="RFC"
                            >
                        </div>
                    </div>

                    <div class="col" *ngIf=" tipoPersonaCombo==2">
                        <div class="form-group ">
                            <label>Número de Cliente</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder='Número de Cliente'
                                [(ngModel)]="persona.ClaveCia"
                                name="ClaveCia"
                            >
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="persona.TipoPersona==1">
                <div class="row ">
                    <div class="col ">
                        <div class="form-group">
                            <label>Número de Empleado</label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder='Número de Empleado'
                                [(ngModel)]="persona.ClaveCia"
                                name="ClaveCia"
                            >
                        </div>
                    </div>

                    <div class="col ">
                        <div class="form-group ">
                            <label>Área</label>
                            <select 
                                class="form-control"
                                name="AreaId" 
                                id="AreaId"
                                [(ngModel)]="persona.AreaId"
                            >
                                <option value="-1">Selecciona una Opción</option>
                                <option value="{{ area.areaId}}" 
                                    *ngFor="let area of areas">
                                    {{ area.area }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col ">
                        <div class="form-group ">
                            <label>Sucursal</label>
                            <select
                                class="form-control"
                                name="SucursalId"
                                id="SucursalId"
                                [(ngModel)]="persona.SucursalId"
                            >
                                <option value="-1">Selecciona una Opción</option>
                                <option value="{{ sucursal.sucursalId }}"
                                    *ngFor="let sucursal of sucursales">
                                    {{sucursal.sucursal }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col ">
                        <div class="form-group ">
                            <label>Estatus</label>
                            <select 
                                class="form-control"
                                name="EstatusId"
                                id="EstatusId"
                                [(ngModel)]="persona.EstatusId">
                                <option value="-1">Selecciona una Opción</option>
                                <option value="{{ es.estatusId }}" 
                                    *ngFor="let es of estatus">
                                    {{ es.estatus }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right ">
                <button class="btn btn-info ">Buscar</button>
            </div>
        </div>
    </div>
</form>


<div class="card" >
    <lib-dynamic-table
        [fromSearchButtom]="fromSearchButtom"
        [activeTotalRowsSection]="true"
        [downloadReport]="true" 
        [columns]="columns"
        [data]="data"
        [pageSize]="15"
        [totalRows]="totalrows"
        (action)="onTableAction($event)"
        (newbatch)="onNewBatch($event)"
        (printReport)="onPrintReport()"
        [loadingTotalRows]="loadingTotalRows">
    </lib-dynamic-table>
</div>